import { Scope } from '@utils'
import {create} from 'zustand'

interface ContactMappingItem {
  id: string
  scope: Scope[]
}

interface ContactMappingStore {
  contactsMap: Record<string, ContactMappingItem[]>

  addContact: (contact: ContactMappingItem) => void
  removeContact: (contactId: string) => void
  isMyContact: (contactId: string) => boolean
  hasContact: (contactId: string) => boolean
  getContacts: (profileId: string) => ContactMappingItem[]
  getCommonContacts: (contactId: string) => ContactMappingItem[]
  getContactDegree: (targetId: string, maxDepth?: number) => number | null
  getScope: (contactId: string) => Scope[]
  updateScope: (contactId: string, scope: Scope[]) => void
  setContacts: (contacts: ContactMappingItem[]) => void
}

export const useContactMappingStore = create<ContactMappingStore>((set, get) => ({
  contactsMap: {
    me: [
      { id: '1', scope: [Scope.PRIVATE] },
      { id: '2', scope: [Scope.GHOST] },
      { id: '3', scope: [Scope.PROFESSIONAL] },
      { id: '4', scope: [Scope.GHOST] },
    ],
    '1': [
      { id: 'me', scope: [Scope.PROFESSIONAL] },
      { id: '2', scope: [Scope.PROFESSIONAL] },
      { id: '3', scope: [Scope.PRIVATE] },
      { id: '4', scope: [Scope.PRIVATE] },
    ],
    '2': [
      { id: 'me', scope: [Scope.PROFESSIONAL] },
      { id: '4', scope: [Scope.PRIVATE] },
    ],
    '3': [
      { id: '1', scope: [Scope.PRIVATE] },
      { id: '2', scope: [Scope.PRIVATE] },
      { id: 'me', scope: [Scope.PROFESSIONAL] },
    ],
    '4': [
      { id: '1', scope: [Scope.PRIVATE] },
      { id: '2', scope: [Scope.PROFESSIONAL] },
    ],
  },

  addContact: (contact) =>
    set(state => {
      const profileId = "me" //TODO
      const contacts = state.contactsMap[profileId] || []
      if (!contacts.some(c => c.id === contact.id)) {
        return {
          contactsMap: {
            ...state.contactsMap,
            [profileId]: [...contacts, contact]
          }
        }
      }
      return state
    }),

  removeContact: (contactId) =>
    set(state => ({
      contactsMap: {
        ...state.contactsMap,
        ["me"]: (state.contactsMap["me"] || []).filter(c => c.id !== contactId)
      }
    })),

  hasContact: (contactId) => {
    return (get().contactsMap["me"] || []).some(c => c.id === contactId)
  },

  isMyContact: (contactId) => {
    return (get().contactsMap["me"] || []).some(c => c.id === contactId)
  },

  getContacts: (profileId) => {
    return get().contactsMap[profileId] || []
  },

  getCommonContacts: (contactId) => {
    //TODO currentUserId
    const setA = get().contactsMap["me"] || []
    const setB = get().contactsMap[contactId] || []
    return setA.filter(a => setB.some(b => b.id === a.id))
  },

  getContactDegree: (contactId, maxDepth = 3) => {
    const { contactsMap } = get()
    const profileId = "me" //TODO
    if (profileId === contactId) return 0

    let visited = new Set<string>([profileId])
    let queue: { id: string; depth: number }[] = [{ id: profileId, depth: 0 }]

    while (queue.length > 0) {
      const { id, depth } = queue.shift()!
      if (depth >= maxDepth) continue

      const contacts = contactsMap[id] || []

      for (const contact of contacts) {
        if (contact.id === contactId) {
          return depth + 1
        }
        if (!visited.has(contact.id)) {
          visited.add(contact.id)
          queue.push({ id: contact.id, depth: depth + 1 })
        }
      }
    }
    return null
  },

  getScope: (contactId) => {
    //should currentUserID
    const contact = (get().contactsMap["me"] || []).find(c => c.id === contactId)
    return contact ? contact.scope : []
  },

  updateScope: (contactId, scope) => 
    set(state => ({
      contactsMap: {
        ...state.contactsMap,
        'me': state.contactsMap['me'].map(c => c.id === contactId? {
          ...c,
          scope
        } : c)
      }
    }))
  ,

  setContacts: (contacts) =>
    set(state => ({
      contactsMap: {
        ...state.contactsMap,
        ["me"]: contacts //TODO
      }
    }))
}))
